/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CatalogProduct,
  CatalogProductCreate,
  CatalogProductReadWithVisibility,
  CatalogProductReadWithoutComponents,
  CatalogProductUsageCheck,
  DuplicateCatalogProductParams,
  ExportCatalogProductsParams,
  GetCatalogProductsParams,
  HTTPValidationError,
  PageCatalogProductReadWithVisibility,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new catalog_product.
 * @summary Create Catalog Product
 */
export const createCatalogProduct = (
  catalogProductCreate: CatalogProductCreate,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogProduct>({
    url: `/api/catalog_product/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: catalogProductCreate,
    signal,
  });
};

export const getCreateCatalogProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCatalogProduct>>,
    TError,
    { data: CatalogProductCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCatalogProduct>>,
  TError,
  { data: CatalogProductCreate },
  TContext
> => {
  const mutationKey = ["createCatalogProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCatalogProduct>>,
    { data: CatalogProductCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createCatalogProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCatalogProduct>>
>;
export type CreateCatalogProductMutationBody = CatalogProductCreate;
export type CreateCatalogProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Catalog Product
 */
export const useCreateCatalogProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCatalogProduct>>,
      TError,
      { data: CatalogProductCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCatalogProduct>>,
  TError,
  { data: CatalogProductCreate },
  TContext
> => {
  const mutationOptions = getCreateCatalogProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many catalog_products.

Results are paginated.
 * @summary Get Catalog Products
 */
export const getCatalogProducts = (
  params?: GetCatalogProductsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageCatalogProductReadWithVisibility>({
    url: `/api/catalog_product/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCatalogProductsInfiniteQueryKey = (
  params?: GetCatalogProductsParams,
) => {
  return [
    "infinite",
    "api",
    "catalog_product",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCatalogProductsQueryKey = (
  params?: GetCatalogProductsParams,
) => {
  return ["api", "catalog_product", ...(params ? [params] : [])] as const;
};

export const getGetCatalogProductsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    GetCatalogProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData,
        QueryKey,
        GetCatalogProductsParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCatalogProductsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    QueryKey,
    GetCatalogProductsParams["page"]
  > = ({ signal, pageParam }) =>
    getCatalogProducts(
      { ...params, page: pageParam || params?.["page"] },
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    TError,
    TData,
    QueryKey,
    GetCatalogProductsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogProductsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogProducts>>
>;
export type GetCatalogProductsInfiniteQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetCatalogProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    GetCatalogProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetCatalogProductsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData,
        QueryKey,
        GetCatalogProductsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogProducts>>,
          TError,
          Awaited<ReturnType<typeof getCatalogProducts>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    GetCatalogProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData,
        QueryKey,
        GetCatalogProductsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogProducts>>,
          TError,
          Awaited<ReturnType<typeof getCatalogProducts>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    GetCatalogProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData,
        QueryKey,
        GetCatalogProductsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Catalog Products
 */

export function useGetCatalogProductsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    GetCatalogProductsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData,
        QueryKey,
        GetCatalogProductsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogProductsInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCatalogProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCatalogProductsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogProducts>>
  > = ({ signal }) => getCatalogProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogProducts>>
>;
export type GetCatalogProductsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetCatalogProducts<
  TData = Awaited<ReturnType<typeof getCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetCatalogProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogProducts>>,
          TError,
          Awaited<ReturnType<typeof getCatalogProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogProducts<
  TData = Awaited<ReturnType<typeof getCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogProducts>>,
          TError,
          Awaited<ReturnType<typeof getCatalogProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogProducts<
  TData = Awaited<ReturnType<typeof getCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Catalog Products
 */

export function useGetCatalogProducts<
  TData = Awaited<ReturnType<typeof getCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogProductsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to check for duplicate catalog products.
 * @summary Check Create Catalog Product
 */
export const checkCreateCatalogProduct = (
  catalogProductCreate: CatalogProductCreate,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogProductReadWithoutComponents[]>({
    url: `/api/catalog_product/check-create`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: catalogProductCreate,
    signal,
  });
};

export const getCheckCreateCatalogProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkCreateCatalogProduct>>,
    TError,
    { data: CatalogProductCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkCreateCatalogProduct>>,
  TError,
  { data: CatalogProductCreate },
  TContext
> => {
  const mutationKey = ["checkCreateCatalogProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkCreateCatalogProduct>>,
    { data: CatalogProductCreate }
  > = (props) => {
    const { data } = props ?? {};

    return checkCreateCatalogProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckCreateCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkCreateCatalogProduct>>
>;
export type CheckCreateCatalogProductMutationBody = CatalogProductCreate;
export type CheckCreateCatalogProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Check Create Catalog Product
 */
export const useCheckCreateCatalogProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof checkCreateCatalogProduct>>,
      TError,
      { data: CatalogProductCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof checkCreateCatalogProduct>>,
  TError,
  { data: CatalogProductCreate },
  TContext
> => {
  const mutationOptions = getCheckCreateCatalogProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Export catalog products to CSV with true streaming.
 * @summary Export Catalog Products
 */
export const exportCatalogProducts = (
  params?: ExportCatalogProductsParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/catalog_product/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportCatalogProductsQueryKey = (
  params?: ExportCatalogProductsParams,
) => {
  return [
    "api",
    "catalog_product",
    "export",
    ...(params ? [params] : []),
  ] as const;
};

export const getExportCatalogProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportCatalogProducts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportCatalogProductsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportCatalogProducts>>
  > = ({ signal }) => exportCatalogProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportCatalogProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportCatalogProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportCatalogProducts>>
>;
export type ExportCatalogProductsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useExportCatalogProducts<
  TData = Awaited<ReturnType<typeof exportCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | ExportCatalogProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportCatalogProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCatalogProducts>>,
          TError,
          Awaited<ReturnType<typeof exportCatalogProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportCatalogProducts<
  TData = Awaited<ReturnType<typeof exportCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportCatalogProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCatalogProducts>>,
          TError,
          Awaited<ReturnType<typeof exportCatalogProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportCatalogProducts<
  TData = Awaited<ReturnType<typeof exportCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportCatalogProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Catalog Products
 */

export function useExportCatalogProducts<
  TData = Awaited<ReturnType<typeof exportCatalogProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportCatalogProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportCatalogProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportCatalogProductsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an catalog_product by ID.
 * @summary Get Catalog Product
 */
export const getCatalogProduct = (
  catalogProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogProductReadWithVisibility>({
    url: `/api/catalog_product/${catalogProductId}`,
    method: "GET",
    signal,
  });
};

export const getGetCatalogProductQueryKey = (catalogProductId?: number) => {
  return ["api", "catalog_product", catalogProductId] as const;
};

export const getGetCatalogProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProduct>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCatalogProductQueryKey(catalogProductId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogProduct>>
  > = ({ signal }) => getCatalogProduct(catalogProductId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!catalogProductId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogProduct>>
>;
export type GetCatalogProductQueryError = ErrorType<void | HTTPValidationError>;

export function useGetCatalogProduct<
  TData = Awaited<ReturnType<typeof getCatalogProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProduct>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogProduct>>,
          TError,
          Awaited<ReturnType<typeof getCatalogProduct>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogProduct<
  TData = Awaited<ReturnType<typeof getCatalogProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProduct>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogProduct>>,
          TError,
          Awaited<ReturnType<typeof getCatalogProduct>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogProduct<
  TData = Awaited<ReturnType<typeof getCatalogProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProduct>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Catalog Product
 */

export function useGetCatalogProduct<
  TData = Awaited<ReturnType<typeof getCatalogProduct>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogProduct>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogProductQueryOptions(
    catalogProductId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an catalog_product by ID.
 * @summary Update Catalog Product
 */
export const updateCatalogProduct = (
  catalogProductId: number,
  catalogProductCreate: CatalogProductCreate,
) => {
  return customInstance<CatalogProduct>({
    url: `/api/catalog_product/${catalogProductId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: catalogProductCreate,
  });
};

export const getUpdateCatalogProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCatalogProduct>>,
    TError,
    { catalogProductId: number; data: CatalogProductCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCatalogProduct>>,
  TError,
  { catalogProductId: number; data: CatalogProductCreate },
  TContext
> => {
  const mutationKey = ["updateCatalogProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCatalogProduct>>,
    { catalogProductId: number; data: CatalogProductCreate }
  > = (props) => {
    const { catalogProductId, data } = props ?? {};

    return updateCatalogProduct(catalogProductId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCatalogProduct>>
>;
export type UpdateCatalogProductMutationBody = CatalogProductCreate;
export type UpdateCatalogProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Catalog Product
 */
export const useUpdateCatalogProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCatalogProduct>>,
      TError,
      { catalogProductId: number; data: CatalogProductCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCatalogProduct>>,
  TError,
  { catalogProductId: number; data: CatalogProductCreate },
  TContext
> => {
  const mutationOptions = getUpdateCatalogProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete an catalog_product by ID.
 * @summary Delete Catalog Product
 */
export const deleteCatalogProduct = (catalogProductId: number) => {
  return customInstance<unknown>({
    url: `/api/catalog_product/${catalogProductId}`,
    method: "DELETE",
  });
};

export const getDeleteCatalogProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCatalogProduct>>,
    TError,
    { catalogProductId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCatalogProduct>>,
  TError,
  { catalogProductId: number },
  TContext
> => {
  const mutationKey = ["deleteCatalogProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCatalogProduct>>,
    { catalogProductId: number }
  > = (props) => {
    const { catalogProductId } = props ?? {};

    return deleteCatalogProduct(catalogProductId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCatalogProduct>>
>;

export type DeleteCatalogProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Catalog Product
 */
export const useDeleteCatalogProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCatalogProduct>>,
      TError,
      { catalogProductId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCatalogProduct>>,
  TError,
  { catalogProductId: number },
  TContext
> => {
  const mutationOptions = getDeleteCatalogProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to check if a catalog_product is being used in other tables.
 * @summary Check Catalog Product Usage
 */
export const checkCatalogProductUsage = (
  catalogProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogProductUsageCheck[]>({
    url: `/api/catalog_product/${catalogProductId}/check-usage`,
    method: "GET",
    signal,
  });
};

export const getCheckCatalogProductUsageQueryKey = (
  catalogProductId?: number,
) => {
  return ["api", "catalog_product", catalogProductId, "check-usage"] as const;
};

export const getCheckCatalogProductUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof checkCatalogProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkCatalogProductUsage>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCheckCatalogProductUsageQueryKey(catalogProductId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkCatalogProductUsage>>
  > = ({ signal }) => checkCatalogProductUsage(catalogProductId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!catalogProductId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkCatalogProductUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckCatalogProductUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkCatalogProductUsage>>
>;
export type CheckCatalogProductUsageQueryError =
  ErrorType<void | HTTPValidationError>;

export function useCheckCatalogProductUsage<
  TData = Awaited<ReturnType<typeof checkCatalogProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkCatalogProductUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkCatalogProductUsage>>,
          TError,
          Awaited<ReturnType<typeof checkCatalogProductUsage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckCatalogProductUsage<
  TData = Awaited<ReturnType<typeof checkCatalogProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkCatalogProductUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkCatalogProductUsage>>,
          TError,
          Awaited<ReturnType<typeof checkCatalogProductUsage>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckCatalogProductUsage<
  TData = Awaited<ReturnType<typeof checkCatalogProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkCatalogProductUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check Catalog Product Usage
 */

export function useCheckCatalogProductUsage<
  TData = Awaited<ReturnType<typeof checkCatalogProductUsage>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  catalogProductId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkCatalogProductUsage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCheckCatalogProductUsageQueryOptions(
    catalogProductId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Restore an archived (soft-deleted) catalog product.
 * @summary Restore Catalog Product
 */
export const restoreCatalogProduct = (
  catalogProductId: number,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/catalog_product/restore/${catalogProductId}`,
    method: "POST",
    signal,
  });
};

export const getRestoreCatalogProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreCatalogProduct>>,
    TError,
    { catalogProductId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreCatalogProduct>>,
  TError,
  { catalogProductId: number },
  TContext
> => {
  const mutationKey = ["restoreCatalogProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreCatalogProduct>>,
    { catalogProductId: number }
  > = (props) => {
    const { catalogProductId } = props ?? {};

    return restoreCatalogProduct(catalogProductId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreCatalogProduct>>
>;

export type RestoreCatalogProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Restore Catalog Product
 */
export const useRestoreCatalogProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreCatalogProduct>>,
      TError,
      { catalogProductId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreCatalogProduct>>,
  TError,
  { catalogProductId: number },
  TContext
> => {
  const mutationOptions = getRestoreCatalogProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to duplicate a catalog product by ID.
 * @summary Duplicate Catalog Product
 */
export const duplicateCatalogProduct = (
  catalogProductId: number,
  params: DuplicateCatalogProductParams,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogProduct>({
    url: `/api/catalog_product/${catalogProductId}/duplicate`,
    method: "POST",
    params,
    signal,
  });
};

export const getDuplicateCatalogProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateCatalogProduct>>,
    TError,
    { catalogProductId: number; params: DuplicateCatalogProductParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateCatalogProduct>>,
  TError,
  { catalogProductId: number; params: DuplicateCatalogProductParams },
  TContext
> => {
  const mutationKey = ["duplicateCatalogProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateCatalogProduct>>,
    { catalogProductId: number; params: DuplicateCatalogProductParams }
  > = (props) => {
    const { catalogProductId, params } = props ?? {};

    return duplicateCatalogProduct(catalogProductId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateCatalogProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateCatalogProduct>>
>;

export type DuplicateCatalogProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Duplicate Catalog Product
 */
export const useDuplicateCatalogProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateCatalogProduct>>,
      TError,
      { catalogProductId: number; params: DuplicateCatalogProductParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateCatalogProduct>>,
  TError,
  { catalogProductId: number; params: DuplicateCatalogProductParams },
  TContext
> => {
  const mutationOptions = getDuplicateCatalogProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
